import { render, staticRenderFns } from "./ProgramProgress.vue?vue&type=template&id=3843743a&scoped=true&"
import script from "./ProgramProgress.vue?vue&type=script&lang=ts&"
export * from "./ProgramProgress.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramProgress.vue?vue&type=style&index=0&id=3843743a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843743a",
  null
  
)

export default component.exports